import { Navigate } from 'react-router-dom';
import { PermissionGuard } from '../auth/PermissionGuard';
import { useCanAccessFeature } from '../../hooks/usePermissions';
import { FirmSettingsTab } from './FirmSettingsTab';
import { BrandingTab } from './BrandingTab';
import { TocSection } from './SettingsToc';

/** Paramètres › Cabinet : l'identité du cabinet, puis son habillage. Chaque partie garde son droit. */
export function CabinetSettingsTab() {
  const first = useCanAccessFeature('settings_firm');
  const second = useCanAccessFeature('settings_branding');
  // Aucun des deux droits : la page n'a rien à montrer.
  if (!first && !second) return <Navigate to="/dashboard" replace />;

  return (
    <div className="space-y-12">
      <PermissionGuard feature="settings_firm" fallback={null}>
        <TocSection label="Informations">
          <FirmSettingsTab />
        </TocSection>
      </PermissionGuard>
      <PermissionGuard feature="settings_branding" fallback={null}>
        <TocSection label="Apparence">
          <BrandingTab />
        </TocSection>
      </PermissionGuard>
    </div>
  );
}
